import React from 'react'
import { Pie } from '@ant-design/charts';
import { useEffect, useRef } from 'react'

function arePropsEqual(oldProps, newProps) {
  let x = JSON.stringify(oldProps) === JSON.stringify(newProps)
  return (
    x
  );
}

const DoughnuttCardV3 = React.memo(({ data, percentage }) => {
  console.log({ data })
  {
    const config = {
      appendPadding: 10,
      data,
      angleField: 'value',
      colorField: 'type',
      color: ['#2EA083', '#FF414D', '#FFA931'],
      opacity:0.5,
      radius: 1,
      autoFit: true,
      legend: false,
      innerRadius: 0.83,
      label: {
        type: 'inner',
        offset: '-50%',
        content: "",
        style: {
          fill: '#fff',
          fontSize: 14,
          textAlign: 'center',
        },
      },
      statistic: {
        title: false,
        content: {
          style: {
            whiteSpace: 'pre-wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: 8
          },
          customHtml: function customHtml() {
            return (
              <div>
                <div style={{ fontSize: '24px', fontWeight: "600" }}>{percentage}%</div>
                <div style={{ fontSize: "14px", color: "#191919", fontWeight: "400", marginLeft: "5px", marginTop: "8px", fontFamily: "roboto", color: "grey" }}>overall attendance</div>
              </div>
            )
          }
        },
      },
      annotations: [],
    };
    const tags = ["Present days", "Absent days", 'Leaves']
    const tagcolor = ['#2EA083', '#FF414D',  '#FFA931']
    return (
      <div style={{ width:'100%' }}>
        <div className='monthly-summary-chart-v3' >
          <Pie {...config} />
        </div>
        <div style={{marginTop:20, display: "flex", justifyContent:'space-around' }}>
          {tags.map((tag, index) =>
            <div className="r-c-c" key={index} style={{ marginBottom: "10px", display: "flex", width: 'fit-content' }}>
              <div style={{ backgroundColor: tagcolor[index], width: "15px", height: "15px", borderRadius: "3px", marginRight: "5px" }}></div>
              {/* <div style={{ fontSize: 12 }}>{data[index]?.value}</div> */}
              <div style={{ fontSize: 14, fontWeight: "400", marginLeft: 5 }}>{tag}</div>
            </div>
          )}
        </div>
      </div>
    )
  }
},
  arePropsEqual
)

export default DoughnuttCardV3